import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { LoginDto } from '@base/models/login.dto';
import { ClientActivationInitialInfoDto } from '@client/shared/models/client/client-activation-initial-info.dto';

@Injectable({ providedIn: 'root' })
export class ActivationTokenApiService {

  readonly #http = inject(HttpClient);

  private get endpoint() {
    return `${environment.basePath}/activation-token`;
  }

  validateToken(token: string): Observable<ClientActivationInitialInfoDto> {
    return this.#http.post<ClientActivationInitialInfoDto>(`${this.endpoint}/validate`, { plainToken: token });
  }

  validateTokenWithEmail(token: string, email: string): Observable<boolean> {
    return this.#http.post<boolean>(`${this.endpoint}/validate-email`, { plainToken: token, email: email  });
  }

  validateTokenWithBirthdate(token: string, dateOfBirth: string): Observable<boolean> {
    return this.#http.post<boolean>(`${this.endpoint}/validate-birthdate`, { plainToken: token, dateOfBirth: dateOfBirth  });
  }

  completeActivation(token: string, password: string): Observable<LoginDto> {
    return this.#http.post<LoginDto>(`${this.endpoint}/complete-activation`, { plainToken: token, password: password  });
  }
}
